(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.ComelyLashMap = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var ZONE_COUNT = 7;
  var MIN_LENGTH = 6;
  var PEAK = { min: 8, max: 16 };

  // Zone offsets in mm from the peak length, inner corner (zone 1) to outer corner (zone 7).
  var STYLES = {
    natural: {
      label: 'Natural',
      offsets: [-4, -3, -2, -1, 0, 0, -1],
      summary: 'Follows the natural growth pattern: shortest at the inner corner, gradually longer, with a soft finish at the outer corner.',
      curl: 'C'
    },
    doll: {
      label: 'Doll Eye',
      offsets: [-4, -2, -1, 0, -1, -2, -3],
      summary: 'The longest lengths sit over the center of the eye to open it up and make it look rounder.',
      curl: 'D'
    },
    cat: {
      label: 'Cat Eye',
      offsets: [-5, -4, -3, -2, -1, 0, -1],
      summary: 'Lengths build toward the outer corner to lift and elongate the eye.',
      curl: 'CC'
    },
    open: {
      label: 'Open Eye',
      offsets: [-4, -2, 0, 0, 0, -2, -3],
      summary: 'A wider plateau of longer lengths across the middle of the eye, tapering at both corners.',
      curl: 'CC'
    },
    squirrel: {
      label: 'Squirrel',
      offsets: [-5, -3, -2, -1, 0, -2, -3],
      summary: 'The peak sits between the center and the outer corner, then drops shorter at the very outer edge.',
      curl: 'CC'
    }
  };

  var EYE_SHAPES = {
    almond: { label: 'Almond', tip: 'Almond eyes suit most styles, so choose the map by the look the client wants.' },
    round: { label: 'Round', tip: 'Round eyes are often elongated with cat eye or squirrel maps. A doll eye map can make them look rounder still.' },
    hooded: { label: 'Hooded', tip: 'On hooded lids, lifted curls such as L, LC or M help extensions show past the lid fold.', curl: 'LC' },
    monolid: { label: 'Monolid', tip: 'On monolids, L, LC or M curls lift extensions above the lid so the length is visible.', curl: 'L' },
    downturned: { label: 'Downturned', tip: 'For downturned eyes, this map keeps the outer corner one size shorter so the set does not pull the eye down.', outerTrim: 1 },
    upturned: { label: 'Upturned', tip: 'For upturned eyes, keeping the longest lengths near the center helps balance the outer lift.' }
  };

  var TECHNIQUES = {
    classic: { label: 'Classic', diameters: ['0.10', '0.15', '0.20'], defaultDiameter: '0.15' },
    hybrid: { label: 'Hybrid', diameters: ['0.10', '0.15', '0.20'], defaultDiameter: '0.15', volumeDiameters: ['0.03', '0.05', '0.07', '0.10'], defaultVolumeDiameter: '0.07' },
    volume: { label: 'Volume', diameters: ['0.03', '0.05', '0.07', '0.10'], defaultDiameter: '0.07' },
    mega: { label: 'Mega Volume', diameters: ['0.03'], defaultDiameter: '0.03' }
  };

  var CURLS = ['J', 'B', 'C', 'CC', 'D', 'L', 'LC', 'M'];

  // In-stock COMELYLASH trays (diameter, curl and length options as listed on each product page).
  var TRAYS = [
    { id: 'matte-volume', name: 'Matte Black Volume Trays 0.03 / 0.05 / 0.07', url: 'https://comelylash.com/products/matte-black-volume-lashes-0-03-0-05-0-07', diameters: ['0.03', '0.05', '0.07'], curls: ['J', 'B', 'C', 'CC', 'D'], lengthMin: 6, lengthMax: 16 },
    { id: 'matte-jb', name: 'Matte Black J/B Curl Trays 0.03 / 0.05 / 0.07', url: 'https://comelylash.com/products/j-b-matte-black-volume-lashes-0-03-0-05-0-07', diameters: ['0.03', '0.05', '0.07'], curls: ['J', 'B'], lengthMin: 8, lengthMax: 17 },
    { id: 'matte-classic', name: 'Matte Black Trays 0.10 / 0.15 / 0.20', url: 'https://comelylash.com/products/matte-black-volume-lashes-0-10-0-15-0-20', diameters: ['0.10', '0.15', '0.20'], curls: ['C', 'CC', 'D'], lengthMin: 6, lengthMax: 20 },
    { id: 'matte-special', name: 'Matte Black L/M/LC Special Curl Trays 0.03 / 0.05 / 0.07', url: 'https://comelylash.com/products/l-m-lc-matte-black-volume-lashes-0-03-0-05-0-07', diameters: ['0.03', '0.05', '0.07'], curls: ['L', 'M', 'LC'], lengthMin: 8, lengthMax: 16 },
    { id: 'ultra-volume', name: 'Ultra Black Volume Trays 0.03 / 0.05 / 0.07', url: 'https://comelylash.com/products/ultra-black-volume-lashes-0-03-0-05-0-07', diameters: ['0.03', '0.05', '0.07'], curls: ['C', 'CC', 'D'], lengthMin: 8, lengthMax: 20 },
    { id: 'ultra-jb', name: 'Ultra Black J/B Curl Trays 0.03 / 0.05 / 0.07', url: 'https://comelylash.com/products/j-b-ultra-black-volume-lashes-0-03-0-05-0-07', diameters: ['0.03', '0.05', '0.07'], curls: ['J', 'B'], lengthMin: 8, lengthMax: 16 },
    { id: 'ultra-special', name: 'Ultra Black Special Curl Trays 0.05, Mix 8–16 mm', url: 'https://comelylash.com/products/ultra-black-special-curl-005-mix-8-16mm', diameters: ['0.05'], curls: ['L', 'LC', 'M'], lengthMin: 8, lengthMax: 16, mixOnly: true }
  ];

  function assertKey(table, key, name) {
    if (!Object.prototype.hasOwnProperty.call(table, key)) throw new RangeError('Unknown ' + name + ': ' + key);
  }

  function suggestedCurl(style, eyeShape) {
    assertKey(STYLES, style, 'style');
    assertKey(EYE_SHAPES, eyeShape, 'eye shape');
    return EYE_SHAPES[eyeShape].curl || STYLES[style].curl;
  }

  function zoneLengths(style, eyeShape, peak) {
    assertKey(STYLES, style, 'style');
    assertKey(EYE_SHAPES, eyeShape, 'eye shape');
    var p = Math.round(Number(peak));
    if (!Number.isFinite(p) || p < PEAK.min || p > PEAK.max) {
      throw new RangeError('Peak length must be between ' + PEAK.min + ' and ' + PEAK.max + ' mm.');
    }
    var lengths = STYLES[style].offsets.map(function (offset) { return Math.max(MIN_LENGTH, p + offset); });
    var trim = EYE_SHAPES[eyeShape].outerTrim || 0;
    if (trim) lengths[ZONE_COUNT - 1] = Math.max(MIN_LENGTH, lengths[ZONE_COUNT - 1] - trim);
    return lengths;
  }

  function uniqueSorted(values) {
    return values.filter(function (value, index) { return values.indexOf(value) === index; }).sort(function (a, b) { return a - b; });
  }

  function traysFor(diameter, curl, lengths) {
    var needed = uniqueSorted(lengths);
    return TRAYS.filter(function (tray) {
      return tray.diameters.indexOf(diameter) !== -1 && tray.curls.indexOf(curl) !== -1;
    }).map(function (tray) {
      var missing = needed.filter(function (length) { return length < tray.lengthMin || length > tray.lengthMax; });
      return {
        id: tray.id,
        name: tray.name,
        url: tray.url,
        mixOnly: !!tray.mixOnly,
        coversAll: missing.length === 0,
        missing: missing
      };
    }).sort(function (a, b) { return Number(b.coversAll) - Number(a.coversAll); });
  }

  function generate(input) {
    var style = input.style;
    var eyeShape = input.eyeShape;
    var technique = input.technique;
    assertKey(STYLES, style, 'style');
    assertKey(EYE_SHAPES, eyeShape, 'eye shape');
    assertKey(TECHNIQUES, technique, 'technique');
    var tech = TECHNIQUES[technique];
    var curl = input.curl || suggestedCurl(style, eyeShape);
    if (CURLS.indexOf(curl) === -1) throw new RangeError('Unknown curl: ' + curl);
    var diameter = input.diameter || tech.defaultDiameter;
    if (tech.diameters.indexOf(diameter) === -1) throw new RangeError(tech.label + ' diameter must be one of ' + tech.diameters.join(', '));

    var lengths = zoneLengths(style, eyeShape, input.peak);
    var layers = [{ role: technique === 'hybrid' ? 'Classic lashes' : tech.label + ' lashes', diameter: diameter }];
    if (technique === 'hybrid') {
      var volumeDiameter = input.volumeDiameter || tech.defaultVolumeDiameter;
      if (tech.volumeDiameters.indexOf(volumeDiameter) === -1) throw new RangeError('Hybrid fan diameter must be one of ' + tech.volumeDiameters.join(', '));
      layers.push({ role: 'Volume fans', diameter: volumeDiameter });
    }

    var supplies = layers.map(function (layer) {
      return { role: layer.role, diameter: layer.diameter, curl: curl, trays: traysFor(layer.diameter, curl, lengths) };
    });

    return {
      style: style,
      styleLabel: STYLES[style].label,
      eyeShape: eyeShape,
      eyeShapeLabel: EYE_SHAPES[eyeShape].label,
      technique: technique,
      techniqueLabel: tech.label,
      curl: curl,
      diameterLabel: layers.map(function (layer) { return layer.diameter; }).join(' + '),
      zones: lengths.map(function (length, index) { return { zone: index + 1, length: length }; }),
      lengthsNeeded: uniqueSorted(lengths),
      summary: STYLES[style].summary,
      eyeTip: EYE_SHAPES[eyeShape].tip,
      supplies: supplies
    };
  }

  // ---------- SVG drawing ----------

  var VIEW = { width: 640, height: 420 };
  var LID = { p0: [70, 330], p1: [290, 166], p2: [570, 324] };
  var LOWER = { p0: [70, 330], p1: [365, 396], p2: [570, 324] };
  var PX_PER_MM = 8;
  var CURL_BEND = { J: 0.06, B: 0.1, C: 0.16, CC: 0.2, D: 0.24, L: 0.2, LC: 0.22, M: 0.24 };

  function bezier(curve, t) {
    var a = (1 - t) * (1 - t);
    var b = 2 * (1 - t) * t;
    var c = t * t;
    return [a * curve.p0[0] + b * curve.p1[0] + c * curve.p2[0], a * curve.p0[1] + b * curve.p1[1] + c * curve.p2[1]];
  }

  function normal(curve, t) {
    var dx = 2 * (1 - t) * (curve.p1[0] - curve.p0[0]) + 2 * t * (curve.p2[0] - curve.p1[0]);
    var dy = 2 * (1 - t) * (curve.p1[1] - curve.p0[1]) + 2 * t * (curve.p2[1] - curve.p1[1]);
    var len = Math.sqrt(dx * dx + dy * dy) || 1;
    return [dy / len, -dx / len];
  }

  // y of the lower lid at a given x (unmirrored), found by bisection on the curve.
  function lowerYAt(xValue) {
    var low = 0, high = 1;
    for (var i = 0; i < 30; i++) {
      var middle = (low + high) / 2;
      if (bezier(LOWER, middle)[0] < xValue) low = middle; else high = middle;
    }
    return bezier(LOWER, (low + high) / 2)[1];
  }

  function fmt(n) { return Math.round(n * 10) / 10; }

  function curvePath(curve, mirror) {
    var x = function (v) { return mirror ? VIEW.width - v : v; };
    return 'M' + fmt(x(curve.p0[0])) + ' ' + curve.p0[1] + ' Q' + fmt(x(curve.p1[0])) + ' ' + curve.p1[1] + ' ' + fmt(x(curve.p2[0])) + ' ' + curve.p2[1];
  }

  function escapeText(value) {
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  var svgCount = 0;

  function eyeOutline(mirror) {
    var x = function (v) { return fmt(mirror ? VIEW.width - v : v); };
    return 'M' + x(LID.p0[0]) + ' ' + LID.p0[1] + ' Q' + x(LID.p1[0]) + ' ' + LID.p1[1] + ' ' + x(LID.p2[0]) + ' ' + LID.p2[1] +
      ' Q' + x(LOWER.p1[0]) + ' ' + LOWER.p1[1] + ' ' + x(LOWER.p0[0]) + ' ' + LOWER.p0[1] + ' Z';
  }

  var LASHES_PER_ZONE = 6;
  var SHEET_WIDTH = 1040;

  // One tapered lash: wide at the lash line, fine at the tip, curving toward the outer corner.
  function lashPath(t, lengthPx, bend, x) {
    var base = bezier(LID, t);
    var n = normal(LID, t);
    var side = [-n[1], n[0]];
    var tip = [base[0] + n[0] * lengthPx, base[1] + n[1] * lengthPx];
    var ctrl = [base[0] + n[0] * lengthPx * 0.5 + side[0] * lengthPx * bend, base[1] + n[1] * lengthPx * 0.5 + side[1] * lengthPx * bend];
    var half = 1.15;
    var p = function (point) { return fmt(x(point[0])) + ' ' + fmt(point[1]); };
    var b1 = [base[0] + side[0] * half, base[1] + side[1] * half];
    var b2 = [base[0] - side[0] * half, base[1] - side[1] * half];
    var c1 = [ctrl[0] + side[0] * half * 0.55, ctrl[1] + side[1] * half * 0.55];
    var c2 = [ctrl[0] - side[0] * half * 0.55, ctrl[1] - side[1] * half * 0.55];
    return '<path d="M' + p(b1) + ' Q' + p(c1) + ' ' + p(tip) + ' Q' + p(c2) + ' ' + p(b2) + ' Z" fill="#3b302c"/>';
  }

  // options: { lengths: [7 numbers] | null (blank), curl, mirror, title, caption }
  function renderSvg(options) {
    var mirror = !!options.mirror;
    var lengths = options.lengths;
    var blank = !lengths;
    var bend = CURL_BEND[options.curl] || 0.16;
    var peak = blank ? null : Math.max.apply(null, lengths);
    var x = function (v) { return mirror ? VIEW.width - v : v; };
    var id = 'lm' + (++svgCount);
    var font = 'font-family="Inter, Arial, sans-serif"';
    var pupilX = fmt(x(bezier(LID, 0.5)[0]));
    var parts = [];
    parts.push('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + VIEW.width + ' ' + VIEW.height + '" role="img" aria-labelledby="' + id + '-title">');
    parts.push('<title id="' + id + '-title">' + escapeText(options.title || 'Lash map') + '</title>');
    var pupilPoint = bezier(LID, 0.5);
    var irisY = 304;
    parts.push('<defs>' +
      '<linearGradient id="' + id + '-bg" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffffff"/><stop offset="1" stop-color="#fbf6f1"/></linearGradient>' +
      '<radialGradient id="' + id + '-iris" cx=".5" cy=".5" r=".5"><stop offset="0" stop-color="#cfa983"/><stop offset=".55" stop-color="#a77c5b"/><stop offset=".9" stop-color="#835e45"/><stop offset="1" stop-color="#704f3b"/></radialGradient>' +
      '<linearGradient id="' + id + '-shade" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#8a6a5a" stop-opacity=".14"/><stop offset=".35" stop-color="#6b4a3a" stop-opacity="0"/></linearGradient>' +
      '<clipPath id="' + id + '-eye"><path d="' + eyeOutline(mirror) + '"/></clipPath>' +
      '</defs>');
    parts.push('<rect width="100%" height="100%" fill="url(#' + id + '-bg)"/>');
    // Open eye in a soft illustration style: the iris tucks under the upper lid like a relaxed eye.
    parts.push('<path d="' + eyeOutline(mirror) + '" fill="#fffcfa"/>');
    parts.push('<g clip-path="url(#' + id + '-eye)">' +
      '<circle cx="' + pupilX + '" cy="' + irisY + '" r="60" fill="url(#' + id + '-iris)" stroke="#704f3b" stroke-width="1" stroke-opacity=".8"/>' +
      '<circle cx="' + pupilX + '" cy="' + irisY + '" r="19" fill="#2e2420"/>' +
      '<circle cx="' + fmt(Number(pupilX) + 18) + '" cy="' + (irisY - 19) + '" r="9" fill="#ffffff" opacity=".95"/>' +
      '<circle cx="' + fmt(Number(pupilX) - 17) + '" cy="' + (irisY + 18) + '" r="4" fill="#ffffff" opacity=".6"/>' +
      '<ellipse cx="' + fmt(x(88)) + '" cy="329" rx="16" ry="9" fill="#eab3ad" opacity=".85"/>' +
      '<path d="' + eyeOutline(mirror) + '" fill="url(#' + id + '-shade)"/>' +
      '</g>');
    parts.push('<path d="' + curvePath(LOWER, mirror) + '" fill="none" stroke="#dcc4b9" stroke-width="2.2" stroke-linecap="round"/>');
    // Pupil center guide: many artists mark the top of the pupil as the center reference.
    parts.push('<line x1="' + pupilX + '" y1="' + fmt(pupilPoint[1] - 8) + '" x2="' + pupilX + '" y2="44" stroke="#b4536a" stroke-width="1.2" stroke-dasharray="2 5" opacity=".7"/>');
    parts.push('<text x="' + pupilX + '" y="34" text-anchor="middle" ' + font + ' font-size="12" font-weight="600" letter-spacing="1" fill="#b4536a">PUPIL CENTER</text>');

    var zoneWidth = 1 / ZONE_COUNT;
    for (var z = 0; z < ZONE_COUNT; z++) {
      var tStart = z * zoneWidth;
      var tMid = tStart + zoneWidth / 2;
      if (z > 0) {
        var edge = bezier(LID, tStart);
        var edgeNormal = normal(LID, tStart);
        parts.push('<line x1="' + fmt(x(edge[0])) + '" y1="' + fmt(edge[1]) + '" x2="' + fmt(x(edge[0] + edgeNormal[0] * 150)) + '" y2="' + fmt(edge[1] + edgeNormal[1] * 150) + '" stroke="#e3dbd0" stroke-width="1.5" stroke-dasharray="4 5"/>');
      }
      if (!blank) {
        var lengthPx = lengths[z] * PX_PER_MM;
        for (var s = 0; s < LASHES_PER_ZONE; s++) {
          var t = tStart + zoneWidth * (s + 0.5) / LASHES_PER_ZONE;
          // Alternate the curve a little so the row looks natural, not stamped.
          parts.push(lashPath(t, lengthPx, bend * (s % 2 ? 0.85 : 1.1), x));
        }
      }
      var mid = bezier(LID, tMid);
      var midNormal = normal(LID, tMid);
      var labelDistance = blank ? 128 : lengths[z] * PX_PER_MM + 26;
      var label = [mid[0] + midNormal[0] * labelDistance, mid[1] + midNormal[1] * labelDistance];
      var isPeak = !blank && lengths[z] === peak;
      parts.push('<circle cx="' + fmt(x(label[0])) + '" cy="' + fmt(label[1]) + '" r="19" fill="' + (blank ? '#ffffff' : (isPeak ? '#b4536a' : '#f6e6ea')) + '" stroke="#b4536a" stroke-width="1.5"/>');
      if (!blank) {
        parts.push('<text x="' + fmt(x(label[0])) + '" y="' + fmt(label[1] + 6) + '" text-anchor="middle" ' + font + ' font-size="17" font-weight="700" fill="' + (isPeak ? '#ffffff' : '#1d1b1a') + '">' + lengths[z] + '</text>');
      }
      // Zone numbers sit under the lower lid so they never cover the eye.
      parts.push('<text x="' + fmt(x(mid[0])) + '" y="' + fmt(lowerYAt(mid[0]) + 22) + '" text-anchor="middle" ' + font + ' font-size="13" font-weight="600" fill="#8a837e">' + (z + 1) + '</text>');
    }

    parts.push('<path d="' + curvePath(LID, mirror) + '" fill="none" stroke="#3b302c" stroke-width="2.6" stroke-linecap="round"/>');
    parts.push('<circle cx="' + pupilX + '" cy="' + fmt(pupilPoint[1]) + '" r="4.5" fill="#b4536a" stroke="#ffffff" stroke-width="2"/>');
    parts.push('<text x="' + fmt(x(34)) + '" y="335" text-anchor="middle" ' + font + ' font-size="14" font-weight="700" fill="#1d1b1a">Inner</text>');
    parts.push('<text x="' + fmt(x(606)) + '" y="329" text-anchor="middle" ' + font + ' font-size="14" font-weight="700" fill="#1d1b1a">Outer</text>');
    // Which eye: a clear badge in the top corner (mirrored maps are the client's right eye).
    var sideLabel = mirror ? 'RIGHT EYE' : 'LEFT EYE';
    parts.push('<rect x="16" y="14" width="104" height="30" rx="15" fill="#1d1b1a"/>');
    parts.push('<text x="68" y="34" text-anchor="middle" ' + font + ' font-size="13" font-weight="700" letter-spacing="1" fill="#ffffff">' + sideLabel + '</text>');
    if (options.caption) {
      parts.push('<text x="320" y="410" text-anchor="middle" ' + font + ' font-size="13" fill="#5a5552">' + escapeText(options.caption) + '</text>');
    }
    parts.push('</svg>');
    return parts.join('');
  }

  // Small bar sparkline of a style's length profile, used on the style buttons.
  function styleThumb(style) {
    assertKey(STYLES, style, 'style');
    var offsets = STYLES[style].offsets;
    var bars = offsets.map(function (offset, index) {
      var height = 6 + (offset + 5) * 2.8;
      return '<rect x="' + (index * 6) + '" y="' + fmt(22 - height) + '" width="4" height="' + fmt(height) + '" rx="1.5"/>';
    }).join('');
    return '<svg class="comely-map__thumb" viewBox="0 0 40 22" aria-hidden="true" focusable="false">' + bars + '</svg>';
  }

  // ---------- Browser behavior ----------

  function mount(rootElement) {
    var form = rootElement.querySelector('[data-map-form]');
    var mapHolder = rootElement.querySelector('[data-map-svg]');
    var curlSelect = rootElement.querySelector('[data-map-curl]');
    var peakInput = rootElement.querySelector('[data-map-peak]');
    var peakOutput = rootElement.querySelector('[data-map-peak-output]');
    var diameterSelect = rootElement.querySelector('[data-map-diameter]');
    var volumeField = rootElement.querySelector('[data-map-volume-field]');
    var volumeSelect = rootElement.querySelector('[data-map-volume-diameter]');
    var curlTouched = false;
    var lastResult = null;

    function checked(name) {
      var input = form.querySelector('[name="' + name + '"]:checked');
      return input ? input.value : null;
    }

    function write(selector, value) {
      var element = rootElement.querySelector(selector);
      if (element) element.textContent = value;
    }

    function fillOptions(select, values, selected) {
      select.innerHTML = values.map(function (value) {
        return '<option value="' + value + '"' + (value === selected ? ' selected' : '') + '>' + value + ' mm</option>';
      }).join('');
    }

    function syncTechnique() {
      var tech = TECHNIQUES[checked('map-technique')];
      var current = diameterSelect.value;
      fillOptions(diameterSelect, tech.diameters, tech.diameters.indexOf(current) !== -1 ? current : tech.defaultDiameter);
      diameterSelect.disabled = tech.diameters.length === 1;
      volumeField.hidden = !tech.volumeDiameters;
      if (tech.volumeDiameters && !volumeSelect.options.length) fillOptions(volumeSelect, tech.volumeDiameters, tech.defaultVolumeDiameter);
    }

    function renderSupplies(result) {
      var list = rootElement.querySelector('[data-map-supplies]');
      list.innerHTML = result.supplies.map(function (supply) {
        var heading = '<h4>' + escapeText(supply.role) + ' · ' + supply.diameter + ' mm · ' + supply.curl + ' curl</h4>';
        if (!supply.trays.length) {
          return '<li>' + heading + '<p>We do not currently list a ' + supply.diameter + ' mm tray in ' + supply.curl + ' curl. Try another curl or diameter.</p></li>';
        }
        return '<li>' + heading + supply.trays.map(function (tray) {
          var note = tray.mixOnly ? 'Mixed 8–16 mm tray.' : (tray.coversAll ? 'Covers every length in this map.' : 'Not listed in ' + tray.missing.join(', ') + ' mm. Check the product page for options.');
          return '<a href="' + tray.url + '"><span>' + escapeText(tray.name) + '</span><small>' + note + '</small></a>';
        }).join('') + '</li>';
      }).join('');
    }

    function render() {
      if (!curlTouched) curlSelect.value = suggestedCurl(checked('map-style'), checked('map-eye'));
      var input = {
        style: checked('map-style'),
        eyeShape: checked('map-eye'),
        technique: checked('map-technique'),
        curl: curlSelect.value,
        diameter: diameterSelect.value,
        volumeDiameter: volumeField.hidden ? null : volumeSelect.value,
        peak: Number(peakInput.value)
      };
      var result = generate(input);
      lastResult = result;
      var mirror = checked('map-side') === 'right';
      peakOutput.textContent = input.peak + ' mm';
      mapHolder.innerHTML = renderSvg({
        lengths: result.zones.map(function (zone) { return zone.length; }),
        curl: result.curl,
        mirror: mirror,
        title: result.styleLabel + ' lash map for ' + result.eyeShapeLabel.toLowerCase() + ' eyes',
        caption: result.styleLabel + ' · ' + result.curl + ' curl · ' + result.diameterLabel + ' mm · ' + (mirror ? 'right' : 'left') + ' eye'
      });
      write('[data-map-title]', result.styleLabel + ' map · ' + result.eyeShapeLabel + ' eyes');
      write('[data-map-summary]', result.summary);
      write('[data-map-tip]', result.eyeTip);
      write('[data-map-lengths]', result.lengthsNeeded.join(', ') + ' mm');
      var peak = Math.max.apply(null, result.zones.map(function (zone) { return zone.length; }));
      var row = rootElement.querySelector('[data-map-zones]');
      row.innerHTML = result.zones.map(function (zone) {
        var height = Math.round(28 + (zone.length - MIN_LENGTH) / (PEAK.max - MIN_LENGTH) * 72);
        return '<li' + (zone.length === peak ? ' class="is-peak"' : '') + '>' +
          '<span class="comely-map__bar"><span style="height:' + height + '%"></span></span>' +
          '<strong>' + zone.length + '<small> mm</small></strong><em>Zone ' + zone.zone + '</em></li>';
      }).join('');
      var tags = rootElement.querySelector('[data-map-tags]');
      tags.innerHTML = [result.styleLabel, result.curl + ' curl', result.diameterLabel + ' mm', 'Peak ' + input.peak + ' mm', (mirror ? 'Right' : 'Left') + ' eye']
        .map(function (tag) { return '<li>' + escapeText(tag) + '</li>'; }).join('');
      renderSupplies(result);
    }

    function svgToPng(svgMarkup, filename) {
      loadSvg(svgMarkup, function (image) {
        var canvas = document.createElement('canvas');
        canvas.width = VIEW.width * 2;
        canvas.height = VIEW.height * 2;
        canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
        downloadCanvas(canvas, filename);
      });
    }

    var previewElement = null;

    function sheetData(blank) {
      return {
        blank: blank,
        lengths: blank ? null : lastResult.zones.map(function (zone) { return zone.length; }),
        curl: lastResult.curl,
        heading: blank ? 'Blank lash map' : lastResult.styleLabel + ' lash map · ' + lastResult.curl + ' curl · ' + lastResult.diameterLabel + ' mm',
        filename: blank ? 'blank-lash-map.png' : 'lash-map-' + lastResult.style + '-' + lastResult.curl + '.png'
      };
    }

    function sheetEyes(data) {
      return {
        right: renderSvg({ lengths: data.lengths, curl: data.curl, mirror: true, title: 'Right eye', caption: 'Right eye' }),
        left: renderSvg({ lengths: data.lengths, curl: data.curl, mirror: false, title: 'Left eye', caption: 'Left eye' })
      };
    }

    function sheetMarkup(data) {
      var eyes = sheetEyes(data);
      return '<h2>' + escapeText(data.heading) + '</h2>' +
        '<div class="comely-map-sheet__fields"><span>Client</span><span>Date</span><span>Curl</span><span>Diameter</span></div>' +
        '<div class="comely-map-sheet__eyes">' + eyes.right + eyes.left + '</div>' +
        '<p>Free lash map generator from COMELYLASH · comelylash.com/pages/lash-map-generator</p>';
    }

    function loadSvg(markup, done) {
      var image = new Image();
      var url = URL.createObjectURL(new Blob([markup], { type: 'image/svg+xml;charset=utf-8' }));
      image.onload = function () { URL.revokeObjectURL(url); done(image); };
      image.src = url;
    }

    function downloadCanvas(canvas, filename) {
      canvas.toBlob(function (png) {
        var link = document.createElement('a');
        link.href = URL.createObjectURL(png);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
      }, 'image/png');
    }

    // Draws the full sheet (heading, fields, both eyes) as one landscape PNG.
    function saveSheetImage(data) {
      var eyes = sheetEyes(data);
      loadSvg(eyes.right, function (rightImage) {
        loadSvg(eyes.left, function (leftImage) {
          var canvas = document.createElement('canvas');
          canvas.width = 2000;
          canvas.height = 1000;
          var context = canvas.getContext('2d');
          context.fillStyle = '#ffffff';
          context.fillRect(0, 0, canvas.width, canvas.height);
          context.fillStyle = '#1d1b1a';
          context.font = '700 40px Inter, Arial, sans-serif';
          context.fillText(data.heading, 40, 70);
          context.font = '24px Inter, Arial, sans-serif';
          context.fillStyle = '#5a5552';
          context.strokeStyle = '#1d1b1a';
          ['Client', 'Date', 'Curl', 'Diameter'].forEach(function (label, index) {
            var x = 40 + index * 485;
            context.fillText(label, x, 140);
            context.beginPath();
            context.moveTo(x, 150);
            context.lineTo(x + 445, 150);
            context.stroke();
          });
          context.drawImage(rightImage, 40, 190, 950, 623);
          context.drawImage(leftImage, 1010, 190, 950, 623);
          context.fillText('Free lash map generator from COMELYLASH · comelylash.com/pages/lash-map-generator', 40, 850);
          downloadCanvas(canvas, data.filename);
        });
      });
    }

    function closePreview() {
      if (!previewElement) return;
      previewElement.remove();
      previewElement = null;
      document.body.classList.remove('comely-map-preview-open', 'comely-map-printing');
      document.removeEventListener('keydown', onPreviewKey);
      window.removeEventListener('resize', fitPreview);
    }

    // The preview always shows the landscape sheet; on narrow screens it is scaled down to fit.
    function fitPreview() {
      if (!previewElement) return;
      var page = previewElement.querySelector('.comely-map-preview__page');
      var sheet = previewElement.querySelector('.comely-map-sheet');
      var scale = Math.min(1, page.clientWidth / SHEET_WIDTH);
      sheet.style.transform = 'scale(' + scale + ')';
      page.style.height = Math.ceil(sheet.offsetHeight * scale) + 'px';
    }

    function onPreviewKey(event) {
      if (event.key === 'Escape') closePreview();
    }

    // The preview is appended to <body> so print CSS can hide the rest of the store page.
    // window.print() works on desktop and on phones (iOS and Android open the system print menu).
    function openPreview(blank) {
      closePreview();
      var data = sheetData(blank);
      previewElement = document.createElement('div');
      previewElement.className = 'comely-map-preview';
      previewElement.setAttribute('role', 'dialog');
      previewElement.setAttribute('aria-modal', 'true');
      previewElement.setAttribute('aria-label', 'Print preview');
      previewElement.innerHTML =
        '<div class="comely-map-preview__bar">' +
          '<strong>Print preview</strong>' +
          '<div class="comely-map-preview__buttons">' +
            '<button type="button" data-preview-print>Print</button>' +
            '<button type="button" data-preview-save>Save image</button>' +
            '<button type="button" class="is-secondary" data-preview-close>Close</button>' +
          '</div>' +
        '</div>' +
        '<div class="comely-map-preview__page"><div class="comely-map-sheet">' + sheetMarkup(data) + '</div></div>' +
        '<p class="comely-map-preview__hint">On a phone, Print opens your phone\'s print menu, where you can pick a printer or save the map as a PDF. Landscape paper gives the best fit.</p>';
      document.body.appendChild(previewElement);
      document.body.classList.add('comely-map-preview-open');
      fitPreview();
      window.addEventListener('resize', fitPreview);
      document.addEventListener('keydown', onPreviewKey);
      previewElement.querySelector('[data-preview-close]').addEventListener('click', closePreview);
      previewElement.querySelector('[data-preview-save]').addEventListener('click', function () { saveSheetImage(data); });
      previewElement.querySelector('[data-preview-print]').addEventListener('click', function () {
        document.body.classList.add('comely-map-printing');
        window.print();
      });
      previewElement.addEventListener('click', function (event) {
        if (event.target === previewElement) closePreview();
      });
      previewElement.querySelector('[data-preview-print]').focus();
    }

    window.addEventListener('afterprint', function () {
      document.body.classList.remove('comely-map-printing');
    });

    form.addEventListener('change', function (event) {
      if (event.target === curlSelect) curlTouched = true;
      if (event.target.name === 'map-technique') syncTechnique();
      render();
    });
    peakInput.addEventListener('input', render);
    rootElement.querySelector('[data-map-reset-curl]').addEventListener('click', function () {
      curlTouched = false;
      render();
    });
    rootElement.querySelector('[data-map-download]').addEventListener('click', function () {
      svgToPng(mapHolder.innerHTML, 'lash-map-' + lastResult.style + '-' + lastResult.curl + '.png');
    });
    rootElement.querySelector('[data-map-print-filled]').addEventListener('click', function () { openPreview(false); });
    Array.prototype.forEach.call(rootElement.querySelectorAll('[data-map-print-blank]'), function (button) {
      button.addEventListener('click', function () { openPreview(true); });
    });

    Array.prototype.forEach.call(form.querySelectorAll('[name="map-style"]'), function (input) {
      var label = input.nextElementSibling;
      if (label && !label.querySelector('.comely-map__thumb')) label.insertAdjacentHTML('afterbegin', styleThumb(input.value));
    });
    curlSelect.innerHTML = CURLS.map(function (curl) { return '<option value="' + curl + '">' + curl + ' curl</option>'; }).join('');
    syncTechnique();
    render();
  }

  function mountAll() {
    if (typeof document === 'undefined') return;
    var roots = document.querySelectorAll('[data-comely-lash-map]');
    Array.prototype.forEach.call(roots, mount);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll);
    else mountAll();
  }

  return {
    STYLES: STYLES,
    EYE_SHAPES: EYE_SHAPES,
    TECHNIQUES: TECHNIQUES,
    CURLS: CURLS,
    TRAYS: TRAYS,
    PEAK: PEAK,
    MIN_LENGTH: MIN_LENGTH,
    suggestedCurl: suggestedCurl,
    zoneLengths: zoneLengths,
    traysFor: traysFor,
    generate: generate,
    renderSvg: renderSvg,
    styleThumb: styleThumb
  };
});

